"use client";

import { VideoType } from "@/sections/Alumni";
import CustomImage from "../CustomImage";
import { useState } from "react";
import ReactPlayer from "react-player";
import Text from "../Text";
import Play from "@/public/assets/images/play.svg";
import Pause from "@/public/assets/images/pause.svg";

type AlumniVideoProps = {
  video: VideoType;
};

const AlumniVideo = ({ video }: AlumniVideoProps) => {
  const [isPlaying, setIsPlaying] = useState(false);
  return (
    <div className="alumni-video">
      {!isPlaying ? (
        <CustomImage
          alt={video.image.alt}
          src={video.image.src.desktop}
          srcTablet={video.image.src.tablet}
          srcMobile={video.image.src.mobile}
          className="alumni-video__image"
        />
      ) : (
        <ReactPlayer
          controls={false}
          playing={isPlaying}
          url={video.src}
          onEnded={() => setIsPlaying(false)}
        />
      )}
      <div className="alumni-video__content">
        <button
          className="alumni-video__button"
          onClick={() => setIsPlaying((prev) => !prev)}
        >
          {isPlaying ? <Pause /> : <Play />}
        </button>
        <Text
          element="p"
          elementStyle="subtitle-secondary"
          className="weight-700 dark-gold"
        >
          {video.name}
        </Text>
        <Text element="p" elementStyle="body" className="weight-500 dark-gold">
          {video.text}
        </Text>
      </div>
    </div>
  );
};

export default AlumniVideo;
